import PropTypes from 'prop-types'
import {Flex, Spacer, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const Title = ({onOpenBankAccountDetails}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Flex alignItems="center">
      <Text textStyle={{base: 'headline3', md: 'headline2'}}>
        {t('header.title')}
      </Text>
      <Spacer />
      <Text
        borderBottomWidth={1}
        borderColor="mld.neutral.1000"
        cursor="pointer"
        onClick={onOpenBankAccountDetails}
      >
        {t('header.bankAccountDetailsLink')}
      </Text>
    </Flex>
  )
}

Title.propTypes = {
  onOpenBankAccountDetails: PropTypes.func.isRequired,
}

export default Title
